import React from 'react';
import { ADMIN_FUNCTIONAL_ROLES, REGION_OPTIONS, type AdminFunctionalRole, type Region } from '../common/adminAccess';

interface Props {
    adminRoles: AdminFunctionalRole[];
    regions: Region[];
    disabled?: boolean;
    onChange: (adminRoles: AdminFunctionalRole[], regions: Region[]) => void;
}

const styles = {
    legend: 'text-xs font-bold uppercase text-slate-500',
    option: 'flex items-center gap-2 rounded-lg border border-slate-200 p-2 text-sm text-slate-700',
    checkbox: 'h-4 w-4 accent-blue-600 disabled:opacity-50',
};

const AdminAssignmentFields: React.FC<Props> = ({ adminRoles, regions, disabled = false, onChange }) => (
    <div className="space-y-5">
        <fieldset disabled={disabled}>
            <legend className={styles.legend}>Admin Roles (Optional)</legend>
            <div className="mt-2 grid gap-2 sm:grid-cols-2">
                {ADMIN_FUNCTIONAL_ROLES.map(role => <label key={role} className={styles.option}>
                    <input type="checkbox" className={styles.checkbox} checked={adminRoles.includes(role)} onChange={() => {
                        const selected = adminRoles.includes(role) ? adminRoles.filter(value => value !== role) : [...adminRoles, role];
                        onChange(selected, selected.includes('Regional Consultant') ? regions : []);
                    }} />{role}
                </label>)}
            </div>
        </fieldset>
        {adminRoles.includes('Regional Consultant') && <fieldset disabled={disabled}>
            <legend className={styles.legend}>Served Regions</legend>
            <div className="mt-2 grid gap-2 sm:grid-cols-2">
                {REGION_OPTIONS.map(region => <label key={region} className={styles.option}>
                    <input type="checkbox" className={styles.checkbox} checked={regions.includes(region)} onChange={() =>
                        onChange(adminRoles, regions.includes(region) ? regions.filter(value => value !== region) : [...regions, region])} />{region}
                </label>)}
            </div>
        </fieldset>}
    </div>
);

export default AdminAssignmentFields;
